import classNames from 'classnames';

type Props = {
  className?: string;
};

export const Divider = ({ className }: Props) => {
  return <hr className={classNames('separator border-t-0', className)} />;
};
